module.exports = __webpack_public_path__ + "static/media/samfunnsdialog_android_menu.b80ff457.png";